import $ from 'jquery';
import 'slick-carousel';
window.jQuery = window.$ = $; 

// Function reintilises the testimonial carousel with .is-style-fade to transition fade instead of slide

function slickCarousel() {
    $('.is-style-fade > .is-carousel').removeClass("slick-initialized slick-slider");
    $('.is-style-fade > .is-carousel').slick({
        autoplay: true,
        fade: true,
        cssEase: 'ease-out'
    });
}

$(document).ready(function() {
    slickCarousel();
});